import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/omni_channel.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function OmniChannel() {
    return (
        <Container className='cybersecurity'>
            <h2 className="text-center title">Omnichannel Media & Ads</h2>
            <Row>
                <div className='responsive-title'>Your Brand, Everywhere,  All at Once</div>
            </Row>
            <Row className='mt-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                <p className='text-center mb-4 content'>
                    In today’s hyper-connected world, winning attention means showing up in all the right places with the right message, at the right moment. We help you launch seamless, cross-platform media strategies that don’t just reach people they follow them across devices, channels, and formats.
                </p>
                <p className='text-center mb-4 content'>
                    From screens in their hands to screens in the city, we make sure your brand is seen, heard, and remembered.
                </p>
                </AnimationOnScroll>
            </Row>

            <Row>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.5} offset={100}>
                    <img src={img01} alt="Telecom Innovation Stack" className='img-fluid' style={{ width: '100%', height: 'auto', borderRadius: '25px' }} />
                    </AnimationOnScroll>
                </Col>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__flipInX" duration={.5} offset={100}>
                    <div className='mb-4 box'>
                        <div className='mb-4 box-title'>
                            What's In The Mix:
                        </div>

                        <Row>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Record Label Services</h4>
                                <p>For brands that want to break into music or build with it.</p>
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <h4>Messaging Ads (SMS, WhatsApp, Email)</h4>
                                <p>Direct-to-pocket communication that cuts through the noise.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>TV & Radio Commercials</h4>
                                <p>Classic broadcast, powered by modern targeting and killer production.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>DOOH (Digital Out-of-Home) Media</h4>
                                <p>Big screens, high streets hyper-visual brand presence in the real world.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Music Content Distribution</h4>
                                <p>Get your audio on Spotify, YouTube, or anywhere people stream with purpose</p>
                            </div>



                        </Row>
                    </div>
                    </AnimationOnScroll>
                </Col>

            </Row>


        </Container>
    )

}